import { useMemo, createContext, useContext } from 'react';
import { useFeatureFlags } from "../hooks/useFeatureFlags";
import { jsx as _jsx } from "react/jsx-runtime";
export const makeMockDevice = () => ({
  isMobileDevice: false
});
const DeviceContext = /*#__PURE__*/createContext(makeMockDevice());
export function DeviceProvider(_ref) {
  let {
    children,
    isMobileDevice
  } = _ref;
  const value = useMemo(() => ({
    isMobileDevice
  }), [isMobileDevice]);
  return /*#__PURE__*/_jsx(DeviceContext.Provider, {
    value: value,
    children: children
  });
}
export const useDevice = () => useContext(DeviceContext);
export const useMobileResponsiveness = () => {
  const context = useContext(DeviceContext);
  const {
    MOBILE_RESPONSIVENESS = false
  } = useFeatureFlags();
  return {
    isMobileDevice: MOBILE_RESPONSIVENESS && context.isMobileDevice
  };
};